import { patchRequest } from '@/core';
import { trips } from '@/requests';

export default async function updateTripRequest(id, patch) {
	let url = trips.getByIdPath(id);
	let response = await patchRequest(url, {}, patch);
	return response;
}
